import { AxiosInstance } from 'axios'
import type { DocumentSvcCrunches } from '@dc-shared-web/hooks/api/document/types'

export const fetchDocumentById = async (
  apiClient: AxiosInstance,
  documentId: string
): Promise<DocumentSvcCrunches> => {
  const { data } = await apiClient.get(`/api/crunches/${documentId}`)
  return data
}
